import {
  AsyncStorage,
  experimental_createPersister,
  PersistedQuery,
} from '@tanstack/react-query-persist-client';
import { createStore, del, get, set, UseStore } from 'idb-keyval';

export function newIdbStorage(
  idbStore: UseStore
): AsyncStorage<PersistedQuery> {
  return {
    getItem: async (key) => await get(key, idbStore),
    setItem: async (key, value) => await set(key, value, idbStore),
    removeItem: async (key) => await del(key, idbStore),
  };
}

export const experimentalQueryPersister = (storeName: string) =>
  experimental_createPersister({
    storage: newIdbStorage(createStore(storeName, storeName)),
    maxAge: Infinity,
    serialize: (persistedQuery) => persistedQuery,
    deserialize: (cached) => cached,
  });
